import React from "react";
import PropTypes from "prop-types";
import PureBudgetTable from "../PureBudgetTable";

import { budgetTypeMap } from "../../../../constants";
import BudgetTableComments from "../BudgetTableComments";
import GetStartedCircle from "../../GetStartedCircle/GetStartedCircle";
import useBudgetTableData from "../useBudgetTableData";

const ActivateBudgetTable = ({
  projectId,
  isActivateProject,
  setDraftBudgetLineItems,
  disbaleRowActions,
  onReturnToBudgetView,
}) => {
  const {
    currentUser,
    originalBudgetLineItems,
    budgetGroups,
    budgetType,
    isLockGmp,
    isLockFixedFirm,
    isBudgetLocked,
    users,
    systemConfiguration,
    project,
    tableData,
    selectedRows,
    templateSettings,
    vendors,
    unitsOfMeasure,
    groupedUnitsOfMeasure,
    csiCodes,
    commentsData,
    rateSheetRates,
    spaceConfiguration,
    selectedLineItemForComments,
    setSelectedLineItemForComments,
    isLoadingComments,
    isAllLowRangeChecked,
    isAllHighRangeChecked,
    toggleLowRange,
    toggleHighRange,
    toggleAllHighRange,
    toggleAllLowRange,
    updateUserTemplateSettings,
    deleteUserTemplateSettings,
    versionCloseCallback,
    rowAssociationMenuList,
    validationSchema,
    initialNewRowStateInTableEditing,
    groupByCallback,
    getButtonActions,
    handlePostComment,
    handlePostReply,
    handleRowSelect,
    onViewBudget,
  } = useBudgetTableData({
    projectId,
    isActivateProject,
    setDraftBudgetLineItems,
    disbaleRowActions,
    onReturnToBudgetView,
  });

  if (!originalBudgetLineItems?.length) {
    return (
      <GetStartedCircle
        title="Project Budget"
        className="mx-auto flex justify-center pb-4"
        onGetStartedClicked={onViewBudget}
      />
    );
  }

  return (
    <>
      <PureBudgetTable
        initialNewRowStateInTableEditing={initialNewRowStateInTableEditing}
        disableTableEditing={isBudgetLocked || isLockGmp || isLockFixedFirm}
        validationSchema={validationSchema}
        data={tableData}
        name="budgetLineItems"
        csiCodes={csiCodes}
        groupedUnitsOfMeasure={groupedUnitsOfMeasure}
        unitsOfMeasure={unitsOfMeasure}
        vendors={vendors}
        rateSheetRates={rateSheetRates}
        templateSettings={templateSettings}
        updateUserTemplateSettings={updateUserTemplateSettings}
        deleteUserTemplateSettings={deleteUserTemplateSettings}
        rowAssociationMenuList={rowAssociationMenuList}
        groupByCallback={groupByCallback}
        versionCloseCallback={versionCloseCallback}
        setSelectedRows={handleRowSelect}
        initialSelectedRows={selectedRows}
        buttonActions={getButtonActions()}
        isFixedFirmBudgetType={budgetType?.label === budgetTypeMap.fixedFirm}
        isCostPlusBudgetType={budgetType?.label === budgetTypeMap.costPlus}
        isTimeAndMaterialsBudgetType={
          budgetType?.label === budgetTypeMap.timeAndMaterials
        }
        hasEditPermission={currentUser?.hasPermission?.("budget", "can_write")}
        budgetGroups={budgetGroups}
        setSelectedLineItemForComments={setSelectedLineItemForComments}
        projectLocationSpaceConfiguration={spaceConfiguration}
        systemConfiguration={systemConfiguration}
        users={users}
        isDraftProject={project?.status === "draft"}
        isActivateProject={isActivateProject}
        toggleLowRange={toggleLowRange}
        toggleHighRange={toggleHighRange}
        toggleAllHighRange={toggleAllHighRange}
        toggleAllLowRange={toggleAllLowRange}
        isAllLowRangeChecked={isAllLowRangeChecked}
        isAllHighRangeChecked={isAllHighRangeChecked}
        isLockGmp={isLockGmp}
        isLockFixedFirm={isLockFixedFirm}
        currentUserReference={currentUser?.reference}
        currentUser={currentUser}
      />
      <BudgetTableComments
        currentUser={currentUser}
        isOpen={!!selectedLineItemForComments}
        onRequestModalClose={() => setSelectedLineItemForComments(null)}
        commentsData={commentsData}
        handlePostComment={handlePostComment}
        handlePostReply={handlePostReply}
        isLoadingComments={isLoadingComments}
      />
    </>
  );
};

ActivateBudgetTable.propTypes = {
  projectId: PropTypes.string,
  projectData: PropTypes.shape({
    buildings: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        id: PropTypes.string,
        spaces: PropTypes.arrayOf(
          PropTypes.shape({
            name: PropTypes.string,
            id: PropTypes.string,
            level: PropTypes.string,
          })
        ),
      })
    ),
    members: PropTypes.arrayOf(
      PropTypes.shape({
        user: PropTypes.string,
        position: PropTypes.string,
      })
    ),
    contractualFee: PropTypes.shape({
      feeType: PropTypes.string,
      amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    contractualInsurance: PropTypes.shape({
      insuranceType: PropTypes.string,
      amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    reference: PropTypes.string,
  }),
  isActivateProject: PropTypes.bool,
  setDraftBudgetLineItems: PropTypes.func,
  disbaleRowActions: PropTypes.bool,
  onReturnToBudgetView: PropTypes.func,
};

ActivateBudgetTable.defaultProps = {
  projectId: undefined,
  projectData: undefined,
  isActivateProject: false,
  setDraftBudgetLineItems: () => {},
  disbaleRowActions: false,
  onReturnToBudgetView: () => {},
};

export default ActivateBudgetTable;
